<template>
  <div v-if="loadingOverview" class="loadingScreen"></div>
  <div v-else class="ferryOverview">
    <div class="filtering">
      <div class="filtering__filter">
        <div class="switch">
          <label class="switch__item" for="wandelen" :class="{ '-is-active': this.isActiveFilter('wandelen') }">
            <input class="switch__input" type="radio" id="wandelen" value="wandelen"
              :checked="searchFilter === 'wandelen'" @change="$emit('set-filter', 'wandelen')" />
            <span class="icon -wandelen" :class="{ '-light': this.isActiveFilter('wandelen') }">Wandelen</span>
          </label>

          <label class="switch__item" for="fiets" :class="{ '-is-active': this.isActiveFilter('fiets') }">
            <input class="switch__input" type="radio" id="fiets" value="fiets" :checked="searchFilter === 'fiets'"
              @change="$emit('set-filter', 'fiets')" />
            <span class="icon -fiets" :class="{ '-light': this.isActiveFilter('fiets') }">Fiets</span>
          </label>

          <label class="switch__item" for="auto" :class="{ '-is-active': this.isActiveFilter('auto') }">
            <input class="switch__input" type="radio" id="auto" value="auto" :checked="searchFilter === 'auto'"
              @change="$emit('set-filter', 'auto')" />
            <span class="icon -auto" :class="{ '-light': this.isActiveFilter('auto') }">Auto</span>
          </label>
        </div>
        <!-- .switch -->
      </div>

      <div class="filtering__filter">
        <input class="filtering__searchInput" type="text" placeholder="Plaats, provincie, rivier" @input="autocomplete"
          v-on:keyup.enter="onSearch" v-model="searchLocation" />

        <ul v-if="results.length" class="filtering__autocomplete">
          <li v-for="result in results" :key="result.objectID" class="autocomplete__item">
            <router-link v-if="result.type.slug === 'ferries'" :to="result.link" class="filtering__autocomplete__item"
              :class="result.type.slug">
              <span class="filtering__autocomplete__item__name">{{ result.title }}</span>

              <span class="filtering__autocomplete__item__type">{{ result.type.name }}</span>
            </router-link>

            <button v-else type="button" @click="selectResult(result)" class="filtering__autocomplete__item"
              :class="result.type.slug">
              <span class="filtering__autocomplete__item__name">{{ result.title }}</span>

              <span class="filtering__autocomplete__item__type">{{ result.type.name }}</span>
            </button>
          </li>
        </ul>
      </div>
      <!-- .filtering__filters -->
    </div>
    <!-- .filtering -->

    <div class="relative">
      <ul class="ferryOverview__items" v-if="items.length === 0" v-show="dialogInteracted || !showNotificationsDialog">
        <li class="ferryOverview__item -is-empty">Geen resultaten gevonden.</li>
      </ul>
      <!-- .ferryOverview__items -->

      <ul class="ferryOverview__items" v-if="items.length > 0" v-show="dialogInteracted || !showNotificationsDialog">
        <li class="ferryOverview__item" v-for="ferry in items">
          <router-link class="ferryOverview__itemLink" :to="`/veren/${ferry.slug}`">
            <!-- <h3 class="ferryOverview__itemTitle">{{ ferry.from }} - {{ ferry.to }}</h3> -->
            <h3 class="ferryOverview__itemTitle">{{ ferry.title }}</h3>
            <h4 class="ferryOverview__itemSubtitle" v-if="ferry.type">
              {{ ferry.type.title }}
            </h4>

            <ul class="methods" v-if="ferry.transports">
              <li class="methods__item" v-for="transport in ferry.transports" :class="transport.slug">
                {{ transport.title }}
              </li>
              <!-- .methods__items -->
            </ul>
            <!-- .methods -->
          </router-link>
        </li>
        <!-- .ferryOverview__item -->
      </ul>
      <!-- .ferryOverview__items -->

      <div class="notifications" ref="notifications" v-if="showNotificationsDialog">
        <div class="notifications__inner">
          <div class="notifications__icon">
            <div class="notifications__icon__image"></div>
          </div>

          <button class="notifications__inner__close" v-on:click="toggleNotificationsDialog">
            Venster sluiten
          </button>

          <h2 class="notifications__inner__title">
            Weet altijd of je pont vaart
          </h2>

          <p class="notifications__inner__text">
            Meld je aan en ontvang automatisch een e-mail als er iets verandert.
          </p>

          <h3 class="notifications__inner__subheading">
            Zo doe je dat:
          </h3>

          <ol class="notifications__inner__list">
            <li>
              <span><strong>Klik</strong> op een veerpont op de kaart of gebruik de <strong>zoekfunctie</strong>.</span>
            </li>

            <li>
              <span>Scroll en klik op <strong>aanmelden</strong> voor meldingen.</span>
            </li>
            <li>
              <span>Je ontvangt <strong>automatisch</strong> een e-mail als er iets verandert aan je pont.</span>
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
  <!-- .ferryOverview -->
</template>

<script>
import { algoliasearch } from 'algoliasearch';

export default {
  name: "Overview",
  props: [
    "items",
    "loadingOverview",
    "searchFilter",
    "showNotificationsDialog"
  ],
  watch: {
    searchFilter: function (newValue, oldValue) {
      this.onFilter(newValue);
    },
  },
  data() {
    return {
      algoliaClient: null,
      autocompleteTimeout: null,
      searchLocation: "",
      dialogInit: false,
      dialogInteracted: false,
      results: [],
    };
  },
  mounted() {
    this.client = algoliasearch(
      process.env.ALGOLIA_APPLICATION_ID,
      process.env.ALGOLIA_API_KEY
    );
  },
  updated() {
    if (this.showNotificationsDialog) {
      this.appendNotificationsDialog();
    }
  },
  methods: {
    selectResult(result) {
      this.searchLocation = result.title;

      this.onSearch();
    },
    appendNotificationsDialog() {
      const content = document.getElementById("page");

      if (content && this.$refs.notifications && !this.dialogInit && window.innerWidth > 624) {
        content.appendChild(this.$refs.notifications);
        this.$refs.notifications.classList.add("popover");

        this.dialogInit = true;
      }

      if (content && this.$refs.notifications && !this.dialogInit && window.innerWidth <= 624) {
        window.scrollTo(0, document.body.scrollHeight);

        this.dialogInit = true;
      }
    },
    toggleNotificationsDialog() {
      this.dialogInteracted = true;
      this.$refs.notifications.classList.toggle("hidden");
    },
    isActiveFilter: function (item) {
      return item === this.searchFilter;
    },
    onFilter: function (filter) {
      this.dialogInteracted = true;

      if (this.$refs.notifications) {
        this.$refs.notifications.classList.add("hidden");
      }

      this.$emit("set-filter", filter);
    },
    autocomplete(event) {
      clearTimeout(this.autocompleteTimeout);

      if (this.searchLocation.length <= 2) {
        this.results = [];

        return;
      }

      this.autocompleteTimeout = setTimeout(async () => {
        try {
          const response = await this.client.search([{
            indexName: 'posts',
            query: this.searchLocation,
            hitsPerPage: 5,
            facets: ["*"],
          }]);

          this.results = response.results[0].hits;
        } catch (e) {
          console.log(e);
        }
      }, 250);
    },
    async onSearch() {
      this.results = [];
      this.dialogInteracted = true;

      if (this.$refs.notifications) {
        this.$refs.notifications.classList.add("hidden");
      }

      try {
        const response = await fetch(`https://photon.komoot.io/api/?q=${this.searchLocation}&countrycode=NL&layer=city&layer=state&layer=other&dedupe=0`);
        const data = await response.json();

        if (data) {
          if (Array.isArray(data.features) && data.features.length > 0) {
            this.$emit("map-command", {
              type: "fit-bounds",
              payload: {
                extent: data.features[0].properties.extent,
              }
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped>
*,
*:before,
*:after {
  box-sizing: border-box;
}

.notifications {
  top: 0;
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;

  opacity: 1;

  transition:
    left 0ms 0ms,
    opacity 150ms;
}

.notifications.popover {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;

  padding: 1em;
  background-color: rgba(25, 39, 58, 0.9);
}

.notifications.hidden {
  left: 100vw;
  opacity: 0;

  transition:
    left 0ms 150ms,
    opacity 150ms;
}

.notifications__inner {
  position: relative;

  width: 100%;
  padding: 2.5em 1.25em 2.5em;

  background-color: white;
}

.notifications.popover .notifications__inner {
  max-width: 500px;
  padding-bottom: 1.25em;
}

.notifications__icon {
  position: absolute;
  top: 2.5em;
  right: 1.25em;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 52px;
  height: 52px;
  border-radius: 100%;

  background-color: white;
}

.notifications.popover .notifications__icon {
  top: 0;
  left: 50%;
  right: auto;
  transform: translate(-50%, -50%);

  width: 71px;
  height: 71px;
}

.notifications__icon__image {
  width: 52px;
  height: 52px;
  border-radius: 100%;

  background-color: #8ca833;
  background-image: url("data:image/svg+xml;base64,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");
  background-size: 40px 40px;
  background-repeat: no-repeat;
  background-position: center;
}

.notifications__inner__close {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);

  color: #19273a;
  background-color: transparent;
  background-image: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjMxNDMgNS4xMDQ5OEw1LjEwNDc0IDE1LjMxNDUiIHN0cm9rZT0iIzE5MjczQSIgc3Ryb2tlLXdpZHRoPSIxLjcwMTU5IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuMTA0NzQgNS4xMDQ5OEwxNS4zMTQzIDE1LjMxNDUiIHN0cm9rZT0iIzE5MjczQSIgc3Ryb2tlLXdpZHRoPSIxLjcwMTU5IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==");
  background-size: 21px;
  background-repeat: no-repeat;
  background-position: left center;

  border: 0;
  padding-left: 28px;

  font-family: "Roboto", sans-serif;
  font-size: 1.2em;
  text-transform: lowercase;

  cursor: pointer;
}

.notifications.popover .notifications__inner__close {
  top: 1em;
  left: auto;
  right: 1em;
  bottom: 0;
  transform: none;

  width: 1.5em;
  height: 1.5em;
  padding: 0;

  background-position: center;

  text-indent: 9999em;
  white-space: nowrap;
}

.notifications__inner__title {
  padding-right: 5em;

  margin-top: 0;
  margin-bottom: 6px;

  font-family: "Roboto Condensed";
  font-size: 2em;
  font-weight: normal;
}

.notifications__inner__text {
  padding-right: 5em;

  margin-top: 0;
  margin-bottom: 16px;

  font-size: 1.125em;
}

.notifications.popover .notifications__title,
.notifications.popover .notifications__text {
  padding-right: 0;
}

.notifications__inner__subheading {
  margin-top: 0;
  margin-bottom: 12px;

  font-family: "Roboto Condensed";
  font-size: 1.25em;
  font-weight: normal;
}

.notifications__inner__list {
  list-style: none;
  counter-reset: item;

  margin-top: 0;
  padding: 0;

  font-size: 1.125em;
}

.notifications__inner__list li {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  counter-increment: item;

  padding: 0;
  margin-bottom: 12px;

  line-height: 1.2;
}

.notifications__inner__list li::before {
  content: counter(item);

  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 29px;
  height: 29px;
  margin-right: 12px;
  border-radius: 100%;

  background: #8ca833;
  color: white;

  font-weight: 700;
  font-size: 1.25em;
  text-align: center;
}

.ferryOverview {
  color: #19273a;
}

.relative {
  position: relative;
}

.ferryOverview__items {
  list-style: none;
  margin: 0;
  padding: 0;
}

.ferryOverview__item {
  border-bottom: 1px solid rgba(25, 39, 58, 0.3);
  position: relative;
}

.ferryOverview__item:after {
  content: "";
  font-family: "FontAwesome";
  font-size: 1.2em;
  opacity: 0.5;
  position: absolute;
  right: 1em;
  top: 50%;
  transform: translate(0, -50%);
  transition: transform 0.9s ease-out;
}

.ferryOverview__item:hover:after {
  transform: translate(0.3em, -50%);
  transition: transform 0.4s ease-in-out;
}

.ferryOverview__item.-is-empty {
  font-style: italic;
  opacity: 0.5;
  padding: 1.8em 0.75em;
}

.ferryOverview__item.-is-empty:after {
  content: none;
}

.ferryOverview__itemLink {
  cursor: pointer;
  display: block;
  padding: 1.5em 0.75em;
  text-decoration: none;
}

.ferryOverview__itemTitle,
.ferryOverview__itemSubtitle {
  color: #19273a;
  line-height: 1.2;
  margin: 0;
}

.ferryOverview__itemTitle {
  font-family: "Roboto Condensed", sans-serif;
  font-size: 19.2px;
  font-weight: 400;
}

.ferryOverview__itemSubtitle {
  font-family: "Roboto", sans-serif;
  font-size: 0.75em;
  font-weight: 300;
  line-height: 2;
  margin-bottom: 0.5em;
  opacity: 0.5;
}

@media screen and (min-width: 39em) {
  .ferryOverview {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .ferryOverview__items {
    overflow: auto;
  }
}

.filtering {
  background-color: rgba(25, 39, 58, 0.05);
  border-bottom: 1px solid rgba(25, 39, 58, 0.3);
  padding: 1em 0.75em 0.5em;
}

.filtering__filter {
  position: relative;

  padding: 0.5em 0;
}

.filtering__autocomplete {
  position: absolute;
  z-index: 10;
  top: calc(100% - 8px);
  left: 0;

  width: 100%;
  padding: 0 10px;
  margin: 0;
  border: 1px solid rgba(25, 39, 58, 1);

  background-color: #ffffff;

  list-style-type: none;
}

.filtering__autocomplete__item {
  display: flex;
  flex-direction: column;

  width: 100%;
  padding: 12px 0 12px 28px;
  border: 0;
  border-bottom: 1px solid #cfcfcf;
  outline: 0;

  background-color: transparent;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-position: left center;
  color: #19273a;

  font-family: "Roboto", sans-serif;
  line-height: 1;
  text-align: left;
  text-decoration: none;

  appearance: none;
  cursor: pointer;
}

.filtering__autocomplete__item.ferries {
  background-image: url('../assets/icon-ferry.svg');
}

.filtering__autocomplete__item.vv_city,
.filtering__autocomplete__item.vv_province,
.filtering__autocomplete__item.vv_country {
  background-image: url('../assets/icon-map-pin.svg');
}

.filtering__autocomplete__item.vv_waters {
  background-image: url('../assets/icon-river.svg');
}

.filtering__autocomplete__item__name {
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 3px;
}

.filtering__autocomplete__item__type {
  font-weight: 400;
  font-size: 14px;

  opacity: 0.7;
}

.filtering__searchInput {
  background-color: #ffffff;
  border: 1px solid rgba(25, 39, 58, 0.3);
  font-size: 16px;
  padding: 12px;
  outline: none;
  transition: border-color 0.4s ease-in-out;
  width: 100%;
}

.filtering__searchInput:hover {
  border-color: rgba(25, 39, 58, 0.6);
}

.filtering__searchInput:focus {
  border-color: rgba(25, 39, 58, 1);
}

@media screen and (min-width: 39em) {
  .filtering {
    border-top: 1px solid rgba(25, 39, 58, 0.3);
  }
}

.switch {
  background: #fff;
  border: 1px solid rgba(25, 39, 58, 0.3);
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow: hidden;
}

.switch__item {
  border-right: 1px solid rgba(25, 39, 58, 0.3);
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  padding: 0.8em 0.5em 0.75em;
  position: relative;
  flex-grow: 1;
  text-align: center;
}

.switch__item:last-child {
  border: none;
}

.switch__item.-is-active {
  background-color: #282a79;
}

.switch__input {
  position: absolute;
  top: -20px;
}

.switch .icon {
  margin-right: 0;
}
</style>
